// extracted by mini-css-extract-plugin
export default {"container":"sexpbPvH","imageContainer":"Xm9CsgNP","textBlockMargin":"HtRgBsDX","fromBook":"ItjT9dvq","caption":"ixC_mIBT","credits":"IvVvEE4h"};